// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: linear-gradient(120deg, #5616ea, #320661) !important;
    background-color: #5616ea;
    padding: 20px;
    box-sizing: border-box;
}

.reset-password-form {
    background-color: #ffffff;
    padding: 40px 30px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 500px;
    box-sizing: border-box;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.reset-password-form:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.reset-password-form h1 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    margin-top: 0;
    color: #5616ea;
    text-align: center;
    letter-spacing: 1px;
}

.reset-password-input {
    display: flex;
    margin-bottom: 1.25rem;
    width: 100%;
}

.reset-password-input input {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border-radius: 8px;
    border: 1px solid #ced4da;
    background-color: #f8f9fa;
    color: #495057;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.reset-password-input input::placeholder {
    color: #6c757d;
    font-weight: 400;
}

.reset-password-input input:focus {
  outline: none;
  border-color: #5616ea;
  box-shadow: 0 0 0 2px #5616ea15;
}

.link {
    display: block;
    color: #5616ea;
    font-size: 0.9rem;
    margin-top: 0.5rem;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: color 0.3s ease;
}

.link:hover {
    color: #5616ea;
    text-decoration: underline;
}

.submit-area {
    margin-top: 1.5rem;
    width: 100%;
}

.submit-reset-password {
    width: 100%;
    padding: 0.75rem;
    border-radius: 8px;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    background-color: #5616ea;
    color: #ffffff;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.submit-reset-password:hover {
    background-color: #4a14d6;
    transform: translateY(-2px);
}

.submit-reset-password:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.reset-password-loader {
    border: 2px solid #ffffff;
    border-top: 2px solid #4a14d6;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
    margin-left: 8px;
}

.reset-password-message {
    color: #28a745;
    margin-top: 1rem;
    font-size: 0.95rem;
    font-weight: 600;
    text-align: center;
}

.reset-password-error {
    color: #dc3545;
    margin-top: 1rem;
    font-size: 0.95rem;
    font-weight: 600;
    text-align: center;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media (max-width: 480px) {
    .reset-password-form {
        padding: 30px 20px;
    }

    .reset-password-form h1 {
        font-size: 1.75rem;
        margin-bottom: 1rem;
    }

    .submit-reset-password {
        font-size: 0.95rem;
        padding: 0.65rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gEAAgE;IAChE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,2DAA2D;IAC3D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":[".reset-password-form-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 100vh;\r\n    background: linear-gradient(120deg, #5616ea, #320661) !important;\r\n    background-color: #5616ea;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.reset-password-form {\r\n    background-color: #ffffff;\r\n    padding: 40px 30px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n    width: 100%;\r\n    max-width: 500px;\r\n    box-sizing: border-box;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.reset-password-form:hover {\r\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.reset-password-form h1 {\r\n    font-size: 2rem;\r\n    font-weight: 700;\r\n    margin-bottom: 1.5rem;\r\n    margin-top: 0;\r\n    color: #5616ea;\r\n    text-align: center;\r\n    letter-spacing: 1px;\r\n}\r\n\r\n.reset-password-input {\r\n    display: flex;\r\n    margin-bottom: 1.25rem;\r\n    width: 100%;\r\n}\r\n\r\n.reset-password-input input {\r\n    width: 100%;\r\n    padding: 0.75rem 1rem;\r\n    font-size: 1rem;\r\n    border-radius: 8px;\r\n    border: 1px solid #ced4da;\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.reset-password-input input::placeholder {\r\n    color: #6c757d;\r\n    font-weight: 400;\r\n}\r\n\r\n.reset-password-input input:focus {\r\n  outline: none;\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 2px #5616ea15;\r\n}\r\n\r\n.link {\r\n    display: block;\r\n    color: #5616ea;\r\n    font-size: 0.9rem;\r\n    margin-top: 0.5rem;\r\n    text-decoration: none;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n.link:hover {\r\n    color: #5616ea;\r\n    text-decoration: underline;\r\n}\r\n\r\n.submit-area {\r\n    margin-top: 1.5rem;\r\n    width: 100%;\r\n}\r\n\r\n.submit-reset-password {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    border-radius: 8px;\r\n    border: none;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    background-color: #5616ea;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.2s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.submit-reset-password:hover {\r\n    background-color: #4a14d6;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.submit-reset-password:disabled {\r\n    background-color: #6c757d;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.reset-password-loader {\r\n    border: 2px solid #ffffff;\r\n    border-top: 2px solid #4a14d6;\r\n    border-radius: 50%;\r\n    width: 16px;\r\n    height: 16px;\r\n    animation: spin 1s linear infinite;\r\n    margin-left: 8px;\r\n}\r\n\r\n.reset-password-message {\r\n    color: #28a745;\r\n    margin-top: 1rem;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.reset-password-error {\r\n    color: #dc3545;\r\n    margin-top: 1rem;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .reset-password-form {\r\n        padding: 30px 20px;\r\n    }\r\n\r\n    .reset-password-form h1 {\r\n        font-size: 1.75rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .submit-reset-password {\r\n        font-size: 0.95rem;\r\n        padding: 0.65rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
